// Remove selected row from Page rows
export const RemoveCmsPageRow = (rows: any[], index: number) => {
  return rows.filter((row, i) => i !== index);
};
